import { defineSlotRecipe } from '@chakra-ui/react';
import { cardAnatomy } from '@chakra-ui/react/anatomy';

type ThemeGenCardConfig = {
  borderRadius?: number;
};

export function generateCardSlotRecipe(config?: ThemeGenCardConfig) {
  return defineSlotRecipe({
    slots: cardAnatomy.keys(),
    variants: {
      variant: {
        pageCard: {
          root: {
            backgroundColor: 'bg.info',
            border: '1px solid #b1b1b1',
            borderRadius: config?.borderRadius ?? 4,
            boxShadow: 'none'
          },
          header: {
            padding: '10px'
          },
          body: {
            padding: '10px'
          },
          footer: {
            padding: '10px'
          }
        },
        filterForm: {
          root: {
            background: 'bg.info',
            border: '1px solid #b1b1b1',
            borderRadius: '4px',
            boxShadow: 'none',
            padding: '4px 0px'
          },
          header: {
            padding: '4px 10px'
          },
          body: {
            padding: '10px'
          },
          footer: {
            padding: '4px 10px'
          }
        },
        fieldArray: {
          root: {
            background: 'bg.info',
            border: '1px solid #b1b1b1',
            borderRadius: '4px',
            boxShadow: 'none'
          },
          header: {
            padding: '10px'
          },
          body: {
            padding: '10px'
          },
          footer: {
            padding: '10px'
          }
        },
        toolbar: {
          root: {
            height: 'fit-content',
            width: '100%',
            margin: '4px 0',
            backgroundColor: 'bg.info',
            border: '1px solid #ececec',
            padding: '3px',
            boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.05)'
          },
          header: {
            padding: '0 !important',
            fontWeight: 'bold'
          },
          body: {
            padding: '0 !important',
            margin: '0 !important'
          },

          footer: {
            padding: '0px',
            margin: '0'
          }
        }
      }
    }
  });
}
